import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import generatePDF from 'react-to-pdf';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const TravelTakafulCoverNote = forwardRef((data, ref) => {
  const targetRef = useRef();
  console.log(data?.coverNotedata,"data");

  // Expose `downloadPDF` method to parent via ref
  useImperativeHandle(ref, () => ({
    downloadPDF: () => {
      generatePDF(targetRef, { filename: 'travel-takaful-cover-note.pdf' });
    },
    async generatePDFBlob() {
      if (!targetRef.current) return;

      const canvas = await html2canvas(targetRef.current);
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [canvas.width, canvas.height],
      });

      pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);

      const blob = pdf.output('blob'); // Get the blob
      return blob;
    },
  }));
  return (
    <div className="isb-coverNote">
      <button onClick={() => generatePDF(targetRef, { filename: 'travel-takaful-cover-note.pdf' })}>
        Download PDF
      </button>
      <div className="vfs-coverNoteContent" ref={targetRef}>
        {/* Your PDF content goes here */}
        <>
      <style>{`
        .bodyClass {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          margin: 20px 30px 20px 30px;
          color: #000;
          font-size: 14px;
          max-width: 760px; /* Add a fixed width */
        }

        h1 {
          text-align: center;
          font-size: 30px;
          margin-bottom: 30px;
          text-decoration: none;
        }

        h2 {
          font-size: 16px;
          margin-top: 30px;
          margin-bottom: 10px;
          padding-bottom: 5px;
        }

        .section {
          margin-bottom: 20px;
        }

        .field {
          display: flex;
          margin: 5px 0;
        }

        .label {
          font-size: 15px;
          font-weight: bold;
        }
          .new-label{
          font-size: 15px;
          font-weight: bold;
          }

        .value {
          font-size: 15px;
        }

        .value::before {
          content: ": ";
          font-weight: bold;
        }

        .grouped-fields {
          margin-left: 20px;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        ul {
          margin-left: 20px;
        }

        .note {
          margin-top: 30px;
          font-style: italic;
          color: #333;
        }

        .vfs-top-section {
          display: flex;
          justify-content: space-between;
        }

        .vfs-policyDetails {
          border: 1px solid gray;
          border-radius: 10px;
          padding: 20px 10px;
        }

        .vfs-sectionTwo,
        .vfs-sectionThree {
          display: flex;
          justify-content: space-between;
        }

        .vfs-sectionFour {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-family: Arial, sans-serif;
        }

        th, td {
          border: 1px solid #ccc;
          padding: 10px;
        }

        th:first-child, td:first-child {
          border-right: none;
          text-align: left;
        }

        th:last-child, td:last-child {
          border-left: none;
          text-align: right;
        }

        th {
          background-color: #f2f2f2;
        }

        .customLastRow {
          background-color: rgb(172, 170, 170);
          font-weight: 700;
        }

        .text-center {
          text-align: center;
        }

        .customTableFlex {
          display: flex;
          align-items: baseline;
          justify-content: space-evenly;
        }

        .customTableFlex-Name {
          display: flex;
          align-items: baseline;
        }

        .customTableFlex-Name p {
          margin-left: auto;
          margin-right: auto;
        }

        .subHeading {
          font-size: 25px;
          margin-top: 50px;
          margin-bottom: 25px;
        }
        .subHeadingCoverage{
          font-size: 25px;
          margin-top: 200px;
          margin-bottom: 25px;
        }

        .vfs-logoSection {
          display: flex;
          justify-content: space-between;
        }
          .vfs-logoSection img{
          width: 100px;
          height: 50px;
          }

        .vfs-footer {
          width: 760px;
          margin-top: 40px;
        }
      `}</style>

      <div className="bodyClass">
      <div className="section vfs-logoSection">
        <img src="/assets/coverNote/tbLogo.svg" alt="Takaful Bazaar" />
        <img src="/assets/coverNote/jubilie.svg" alt="Jubilee" />
      </div>

      <h1>Travel Takaful Cover Note</h1>

      <h2 className="subHeading">Takaful Provider Details</h2>
      <div className="section vfs-top-section">
        <div>
          <div className="field"><div className="label">Takaful Provider</div><div className="value">{data?.coverNotedata?.takafulProvider?.companyName}</div></div>
          <div className="field"><div className="label">Line of Business</div><div className="value">{data?.coverNotedata?.lineOfBussiness?.name}</div></div>
          <div className="field"><div className="label">Plan Name</div><div className="value">{data?.coverNotedata?.planName}</div></div>
          <div className="field"><div className="label">Plan Type</div><div className="value">{data?.coverNotedata?.planType?.name}</div></div>
        </div>
        <div className="vfs-policyDetails">
          <div className="field"><div className="label">Order Date</div><div className="value">{data?.coverNotedata?.orderDate}</div></div>
          <div className="field"><div className="label">Order ID</div><div className="value">{data?.coverNotedata?.id}</div></div>
          {/* <div className="field"><div className="label">Policy Start Date</div><div className="value">{data?.coverNotedata?.policyStartDate}</div></div>
          <div className="field"><div className="label">Policy Expiry Date</div><div className="value">{data?.coverNotedata?.policyEndDate}</div></div> */}
          <div className="field"><div className="label">Sale Point</div><div className="value">{data?.coverNotedata?.salePoint?.salesCategory?.value} - {data?.coverNotedata?.salePoint?.salesMedium?.value}</div></div>
        </div>
      </div>

      <h2 className="subHeading">Customer Details</h2>
      <div className="section vfs-sectionTwo">
        <div>
          <div className="field"><div className="label">Name</div><div className="value">{data?.coverNotedata?.name}</div></div>
          <div className="field"><div className="label">Passport Number</div><div className="value">{data?.coverNotedata?.passportNo}</div></div>
          <div className="field"><div className="label">CNIC Issue Date</div><div className="value">{data?.coverNotedata?.cnicIssueDate}</div></div>
          <div className="field"><div className="label">Email Address</div><div className="value">{data?.coverNotedata?.emailAddress}</div></div>
        </div>
        <div>
          <div className="field"><div className="label">Date of Birth</div><div className="value">{data?.coverNotedata?.details?.dateOfBirth}</div></div>
          <div className="field"><div className="label">CNIC Number</div><div className="value">{data?.coverNotedata?.cnicNumber}</div></div>
          <div className="field"><div className="label">Contact Number</div><div className="value">{data?.coverNotedata?.contactNumber}</div></div>
        </div>
      </div>

      <h2 className="subHeading">Beneficiary Details</h2>
      <div className="section vfs-sectionThree">
        <div>
          <div className="field"><div className="label">Name</div><div className="value">{data?.coverNotedata?.details?.beneficiaryDetails?.name}</div></div>
          <div className="field"><div className="label">Contact Number</div><div className="value">{data?.coverNotedata?.details?.beneficiaryDetails?.contactNumber}</div></div>
        </div>
        <div>
          <div className="field"><div className="label">Relation</div><div className="value">{data?.coverNotedata?.details?.beneficiaryDetails?.relation?.key}</div></div>
        </div>
      </div>

      {Array.isArray(data?.coverNotedata?.memberDetails) && data.coverNotedata.memberDetails.length > 0 && (
        <>
          <h2 className="subHeading">Family Details</h2>
          <div className="">
            {data.coverNotedata.memberDetails.map((member, index) => (
              <div key={member.id || index}>
                <div className="section vfs-sectionFour">
                  <div className="d-flex">
                    <h3 className="new-label">Name</h3>
                    <p className="value">{member.name || '-'}</p>
                  </div>
                  <div className="d-flex">
                    <h3 className="new-label">Relation</h3>
                    <p className="value">{member.relationship?.name || '-'}</p>
                  </div>
                  <div className="d-flex w-75">
                    <h3 className="new-label">Passport No</h3>
                    <p className="value">{member.passportNo || '-'}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}


      {/* <div className="section vfs-sectionFour">
        <div className="customTableFlex-Name">
          <h3>1) Name:</h3>
          <p>Zubaida Khan</p>
        </div>
        <div className="customTableFlex">
          <h3>Relation:</h3>
          <p>Wife</p>
        </div>
        <div className="customTableFlex">
          <h3>Passport Number:</h3>
          <p>ABC465788</p>
        </div>
        <div className="customTableFlex-Name">
          <h3>2) Name:</h3>
          <p>Zubaida Khan</p>
        </div>
        <div className="customTableFlex">
          <h3>Relation:</h3>
          <p>Wife</p>
        </div>
        <div className="customTableFlex">
          <h3>Passport Number:</h3>
          <p>ABC465788</p>
        </div>
      </div> */}

      <h2 className="subHeadingCoverage">Coverage Details</h2>
      <table>
  <thead>
    <tr>
      <th>Coverages</th>
      <th>Value</th>
    </tr>
  </thead>
  <tbody>
    {data?.coverNotedata?.travelPlan?.coverages?.map((item, index) => (
      <tr key={index}>
        <td>
          {item.coverage || '—'}
          
        </td>
        <td>
          {item.benefit || '—'}
        </td>
      </tr>
    ))}
  </tbody>
</table>

      {/* <tr className="customLastRow">
            <td>Net Contribution</td>
            <td>Rs. 62,000</td>
          </tr> */}

      <p className="note">
        <strong>Note:</strong> Subject to waiting/activation period. Deductible will apply on Medical Cover for above age individuals.
      </p>

      <div>
        <img className="vfs-footer" src="/assets/coverNote/footer.png" alt="Takaful Bazaar Footer" />
      </div>
    </div>
    </>
      
      </div>
    </div>
  );
});

export default TravelTakafulCoverNote;

